// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataTreeUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { isEmpty, head, get, flow, every, some, filter } from "lodash/fp";
import { EMPTY_GUID } from "logic/data/Izenda.ReportDesignerConstants";

export default {
  /**
   * Get available query source from available tree
   */
  getAvailableQuerySources: (dataTree: array) => {
    return isEmpty(dataTree) ? [] : flow(head, get("querySource"))(dataTree);
  },

  /**
   * Check if selected tree remain at least one selected
   * Note: selected tree contains field that mark unselected
   */
  haveSelectedAtLeastOneQuerySource: (dataTree: array) => {
    return some(cat => some(source => source.selected, cat.querySource), dataTree);
  },

  /**
   * Get selected query sources
   */
  getSelectedQuerySources: (dataTree: array) => {
    let result = [];
    dataTree.forEach(category => {
      category.querySource.forEach(qs => {
        if (qs.selected) {
          const primaryFields = filter(field => {
            const ext = !isEmpty(field.extendedProperties) ? JSON.parse(field.extendedProperties) : {};
            return !isEmpty(ext) && ext.PrimaryKey;
          }, qs.fields);

          result.push({
            aliasId: qs.aliasId,
            querySourceId: qs.id,
            querySourceName: qs.name,
            selected: true,
            categoryId: category.id,
            primaryFields: primaryFields
          });
        }
      });
    });

    return result;
  }
};



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSource/Izenda.DataTreeUtils.js